/**
 * @author 3173
 * @description 个人证书管理 新增/编辑
 * @Date  2020/9/18
 */
import React from "react";
import {connect} from "dva";
import {component_tool, framework_tool, utils_tool} from '../../../../tool';
import PersonalCertForm from './personalCertForm'

let {WizContainer, modelUtils} = framework_tool;
let {WizCard, WizForm, WizSpin} = component_tool;
let {Session} = utils_tool


class PersonalCertDetail extends WizContainer {
  componentName = 'personalCertDetail';

  constructor(props) {
    super(props);
    const {history} = this.props;
    let initialValue = {};
    let cardTitle = '新增';
    if (history.location && history.location.pathname === '/personalCert/personalCertList/personalCertUpd') {
      if (history.location && history.location.record) {
        initialValue = history.location.record;
        Session.set('personalCertUpd', initialValue)
      } else {
        initialValue = Session.get('personalCertUpd') || {};
      }
      cardTitle = '编辑'
      initialValue.type = initialValue.certType;
    }
    this.state = {
      cardTitle: cardTitle,
      formKey: 'certForm',
      certId:initialValue.id||'',
    }
    this.initialValue = initialValue;

  }

  /**
   * ⭐ 只有路由配置时cached: true 才会有此生命周期, 且刷新逻辑需自行实现
   * 编辑时可能会触发重置,如果关键字id不同,则判定是新进入,将重新渲染表单
   */
  _componentDidRecover() {
    const { history } = this.props;
    let initialValue = {};
    if (history.location && history.location.pathname === '/personalCert/personalCertList/personalCertUpd') {
      if (history.location.record) {
        initialValue = history.location.record;
        Session.set('personalCertUpd', initialValue)
      } else {
        initialValue = Session.get('personalCertUpd') || {};
      }
    }
    if (initialValue.id != this.initialValue.id) {
      this.initialValue = initialValue
      this.setState({certId:initialValue.id})
      this._componentDidMount()
    }
  }
  _componentDidMount() {
    // this.doAction({
    //   path: 'categoryType/categoryList',
    //   payload: {
    //     key: "categoryList",
    //     apiParams: {
    //       type: 1,
    //       ids: this.initialValue.categoryIds
    //     }
    //   }
    // });
  }



  propsAndStateOnChange = {
    saveCert: this._saveCertOver.bind(this),
    categoryList: this._getCategoryListOver.bind(this)
  }


  _saveCertOver(nextProps, nextState) {
    if (nextProps.saveCert.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replaceAndDelCrumb', '/personalCert/personalCertList');
    } else {
      wizNotice.error('提交失败：' + nextProps.saveCert.msg);
    }
    return true;
  }

  _getCategoryListOver(nextProps, nextState) {
    if (nextProps.categoryList.code == 1) {
      let categoryList = nextProps.categoryList.data
      for (let i = 0; i < categoryList.length; i++) {
        categoryList[i].title = categoryList[i].name;
        categoryList[i].key =  categoryList[i].id;
      }
      this.initialValue.categoryInfo = nextProps.categoryList.data
    }
    nextState.formKey = 'certForm' + new Date().getTime();
    return true;
  }

  /**
   * 保存/更新
   * @param values
   * @private
   */
  _saveCert(values) {
    const {history} = this.props;
    let apiPath = "certRecord/add";
    if(this.initialValue.id){
      apiPath = "certRecord/update";
    }

    if(values.type && values.type.key){
      values.type = values.type.key;
    }
    if(values.certDate && values.certDate._d){
      values.certDate =  values.certDate._d.getTime();
    }
    if(values.startDate && values.startDate._d){
      values.startDate =  values.startDate._d.getTime();
    }
    if(values.endDate && values.endDate._d){
      values.endDate =  values.endDate._d.getTime();
    }
    if(values.reCheckDate && values.reCheckDate._d){
      values.reCheckDate =  values.reCheckDate._d.getTime();
    }
    if(values.firstDate && values.firstDate._d){
      values.firstDate =  values.firstDate._d.getTime();
    }

    if (values && values['imgMain'] && values['imgMain'].length) {
      values.imgMain = values.imgMain[0].fileId;
    } else {
      values.imgMain = "";
    }
    if (values && values['imgSecondary'] && values['imgSecondary'].length) {
      values.imgSecondary = values.imgSecondary[0].fileId;
    } else {
      values.imgSecondary = "";
    }

    if(values.personId){
      values.entityId = values.personId;
    }

    this.doAction({
      path: apiPath,
      payload: {
        key: "saveCert",
        apiParams: {
          ...values,
          id: this.initialValue.id,
          certDetailId: this.initialValue.certDetail? this.initialValue.certDetail.id : null,
          entityType: 0,//0学员证书
          dataSource: this.initialValue.id?null:0 //如果不是编辑，则为人工导入
        }
      }
    });
  }


  _render() {
    const {certLoading,certRecordLoading} = this.props;
    let {cardTitle,initialValue} = this.state;

    let onSubmit = this._saveCert.bind(this);

    return <WizCard>
      <WizSpin tip={'加载中'} spinning={certLoading || certRecordLoading}>

        <PersonalCertForm className={'form-inline'} key={ this.state.certId || ''} initialValue={this.initialValue} onSubmit={onSubmit}/>

      </WizSpin>
    </WizCard>
  }
}

const mapStateToProps = (state, ownProps) => {
  const {cert,certRecord} = state;
  const saveCert = modelUtils.getModelEntity(certRecord, "saveCert");
  const load = modelUtils.getLoadingState(state, ['cert','certRecord']);
  return {
    saveCert:saveCert,
    ...load
  }
};

export default connect(mapStateToProps)(PersonalCertDetail);
